import api from './index';
let exports = {};

// 服务渠道管理
exports.getServcDistorList = function (params, callback) {// 获取带分页的服务渠道商列表
    api.post('/servcDist/servc/distor/list/get')
    .data(params)
    .done(callback)
    .go();
};
exports.updateServcDistorBlacked = function (params, callback) {// 修改服务渠道商加黑状态
    api.post('/servcDist/servc/distor/blacked/update/do')
    .data(params)
    .done(callback)
    .go();
};
//渠道服务申请单
exports.getDistServcApplyFormList = function (params, callback) {// 获取申请的销售渠道列表
    api.post('/servcDist/dist/servc/apply/form/list/get')
    .data(params)
    .done(callback)
    .go();
};
exports.getDistServcApplyItemList = function (params, callback) {// 获取服务申请项
    api.post('/servcDist/dist/servc/apply/item/list/get')
    .data(params)
    .done(callback)
    .go();
};
exports.getDistServcApplyItemInfoList = function (params, callback) {// 渠道服务申请项并带有地区信息
    api.post('/servcDist/dist/servc/apply/item/info/list/get')
    .data(params)
    .done(callback)
    .go();
};
exports.getDistServcApplyFormInfo = function (params, callback) {// 根据Id获取渠道服务申请单，包括服务信息、申请项信息、申请区域信息
    api.post('/servcDist/dist/servc/apply/form/info/get')
    .data(params)
    .done(callback)
    .go();
};
exports.getDistServcApplyFormInfoByNoAndRecruitId = function (params, callback) {// 根据No和recruitId获取渠道服务申请单，包括服务信息、申请项信息、申请区域信息
    api.post('/servcDist/dist/servc/apply/form/info/get/by/no/and/recruitId')
    .data(params)
    .done(callback)
    .go();
};

exports.updateDistServcApplyForm = function (params, callback) {// 修改服务申请信息
    api.post('/servcDist/dist/servc/apply/form/update/do')
    .data(params)
    .done(callback)
    .go();
};

exports.saveDisitServcApplyFrom = function (params, callback) {// 保存渠道服务
    api.post('/servcDist/dist/servc/save/do')
    .data(params)
    .done(callback)
    .go();
};

exports.getDistServcAuditRecListByNo = function (params, callback) {// 根据no查询申请列表
    api.post('/servcDist/dist/servc/aduit/rec/list/get/by/no')
    .data(params)
    .done(callback)
    .go();
};

exports.getServcRelGoodsListByItemId = function (params, callback) {// 渠道申请项——服务关联商品
    api.post('/servcDist/servc/rel/goods/list/get/by/itemId')
    .data(params)
    .done(callback)
    .go();
};

//应募操作
exports.saveDistServcApplyFormEnList = function (params, callback) {// 保存渠道服务商应募
    api.post('/servcDist/dist/servc/apply/enList/save/do')
    .data(params)
    .done(callback)
    .go();
};

exports.updateServcApplyFormEnList = function (params, callback) {// 更新渠道服务商应募
    api.post('/servcDist/dist/servc/apply/form/enList/update/do')
    .data(params)
    .done(callback)
    .go();
};

exports.resubmitDistServcApplyForm = function (params, callback) {// 再次提交渠道服务再次申请表单
    api.post('/servcDist/dist/servc/apply/form/resubmit/do')
    .data(params)
    .done(callback)
    .go();
};

exports.submitDistServcApplyForm = function (params, callback) {// 提交渠道服务申请表单
    api.post('/servcDist/dist/servc/apply/form/submit/do')
    .data(params)
    .done(callback)
    .go();
};

//获取招募书列表
exports.getServcRecruitList = function (data, callback) {// 获取服务商招募列表(非定向)
    api.post('/servcDist/servc/recruit/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getServcRecruitDirectedList = function (data, callback) {// 获取服务商招募列表(定向)
    api.post('/servcDist/servc/recruit/directed/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//获取招募书信息
exports.getServcRecruit = function (data, callback) {// 获取服务商招募
    api.post('/servcDist/servc/recruit/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取招募服务列表
exports.getServcRecruitItemPagedList = function (data, callback) {// 获取招募的服务列表
    api.post('/servcDist/servc/recruit/item/paged/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取招募服务列表
exports.getServcRecruitItemList = function (data, callback) {// 获取招募的服务列表
    api.post('/servcDist/servc/recruit/item/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取服务区域列表
exports.getServcRecruitRegionList = function (data, callback) {// 获取服务区域列表
    api.post('/servcDist/recruit/region/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取服务招募（书）附件列表
exports.getServcRecruitFileList = function (data, callback) {// 获取服务招募（书）附件列表
    api.post('/servcDist/servc/recruit/file/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcRecruitInfoByRecruitId = function (params, callback) {// 根据渠道商招募书id查找对应的数据
    api.post('/servcDist/servc/recruit/info/get/by/recruitId')
    .data(params)
    .done(callback)
    .go();
};

export default exports;


//////////////////
// WEBPACK FOOTER
// ./src/api/servcDist.js
// module id = 44
// module chunks = 1